import * as modalTypes from "../../../../constants/modalTypes";
import * as objectTypes from "../../../../constants/objectTypes";
import * as optionHelper from "../../../../helpers/optionHelper";
import * as propertyConstants from "../../../../constants/propertyConstants";
import * as translationHelper from "../../../../helpers/translationHelper";

import {
    Colorant,
    createEmptyColorant,
    generateColorantData,
    generateColorantHeadings
} from "../../../../types/colorant";
import React, { Component } from "react";

import { ModalParams } from "../../../../types/modalParams";
import { ModalProperties } from "../../../../types/modalProperties";
import { TableContainer } from "../../../Table";
import { TableHeading } from "../../../../types/tableHeading";

import { t as translate } from "react-i18nify";

type Props = {
    tableConstant: string;
    objectType: objectTypes.ObjectType;
    dataPrivileges: any;
    loading: boolean;
    buttonLoading: boolean;
    allList: Array<Colorant>;
    activeList: Array<Colorant>;
    columnOrder: Array<propertyConstants.Property>;
    columnVisibility: Record<propertyConstants.Property, boolean>;
    columnWidth: Record<propertyConstants.Property, number>;
    offset: number;
    page: number;
    rowCount: number;
    rowCountCustom: boolean;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    showFilterRow: boolean;
    showGlobalSearch: boolean;
    sortingAsc: boolean;
    sortingCriterion: propertyConstants.Property | null;
    totalCount: number | null;
    useTmcNames: boolean;
};

export class MasterColorantTable extends Component<Props> {
    generateTableHeadings = (modalType: modalTypes.ModalType | null = null): Array<TableHeading> => {
        const propertyList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_NAME,
            propertyConstants.PROPERTY_PRINT_NAME,
            propertyConstants.PROPERTY_CODE,
            propertyConstants.PROPERTY_COLOR_RED,
            propertyConstants.PROPERTY_COLOR_GREEN,
            propertyConstants.PROPERTY_COLOR_BLUE,
            propertyConstants.PROPERTY_DENSITY,
            propertyConstants.PROPERTY_BFS,
            propertyConstants.PROPERTY_MIN_DOSAGE,
            propertyConstants.PROPERTY_UFI_CODE,
            propertyConstants.PROPERTY_MORE_INFO,
            propertyConstants.PROPERTY_UUID,
            propertyConstants.PROPERTY_PRIORITY
        ];
        const requiredList: Array<propertyConstants.Property> = [propertyConstants.PROPERTY_NAME];
        const alwaysVisibleList: Array<propertyConstants.Property> = [propertyConstants.PROPERTY_NAME];
        const editableList: Array<propertyConstants.Property> = [...propertyList];
        let visibleList: Array<propertyConstants.Property> = [...propertyList];

        visibleList.splice(6, 0, propertyConstants.PROPERTY_COLOR_RGB_HEX);

        if (this.props.useTmcNames) {
            visibleList.splice(2, 0, propertyConstants.PROPERTY_TMC_NAME);
            editableList.splice(2, 0, propertyConstants.PROPERTY_TMC_NAME);
        }

        let orderList = [...visibleList];

        if (modalType === null) {
            orderList = optionHelper.handleTableHeadingOrder(visibleList, this.props.columnOrder);
            visibleList = optionHelper.handleTableHeadingVisibility(visibleList, this.props.columnVisibility);
        }

        return generateColorantHeadings(
            this.props.objectType,
            orderList,
            visibleList,
            editableList,
            requiredList,
            alwaysVisibleList,
            this.props.columnWidth
        );
    };

    generateAddModalParams = (): ModalParams => {
        return new ModalParams(
            modalTypes.ADD_MODAL,
            this.props.objectType,
            translate("colorant.addColorant"),
            createEmptyColorant(),
            this.generateTableHeadings(modalTypes.MODAL_COLORANTS_ADD)
        );
    };

    generateEditModalParams = (): ModalParams | null => {
        const activeData = generateColorantData(this.props.activeList);

        if (activeData.length) {
            return new ModalParams(
                modalTypes.EDIT_MODAL,
                this.props.objectType,
                translate("colorant.editColorant"),
                activeData[0],
                this.generateTableHeadings(modalTypes.MODAL_COLORANTS_EDIT)
            );
        }

        return null;
    };

    render(): JSX.Element {
        const headings = this.generateTableHeadings();
        const modalProperties: ModalProperties = {
            addModalType: modalTypes.MODAL_COLORANTS_ADD,
            addModalParams: this.generateAddModalParams(),
            editModalType: modalTypes.MODAL_COLORANTS_EDIT,
            editModalParams: this.generateEditModalParams()
        };

        return (
            <div className="height-100">
                <TableContainer
                    className={"table-with-filter"}
                    tableConstant={this.props.tableConstant}
                    objectType={this.props.objectType}
                    dataPrivileges={this.props.dataPrivileges}
                    loading={this.props.loading}
                    buttonLoading={this.props.buttonLoading}
                    title={translationHelper.getTitleSectionTranslation(this.props.objectType)}
                    titleClassName={"main-title"}
                    headings={headings}
                    data={generateColorantData(this.props.allList)}
                    activeData={this.props.activeList}
                    offset={this.props.offset}
                    page={this.props.page}
                    rowCount={this.props.rowCount}
                    rowCountCustom={this.props.rowCountCustom}
                    search={this.props.search}
                    searchParams={this.props.searchParams}
                    showFilterRow={this.props.showFilterRow}
                    showGlobalSearch={this.props.showGlobalSearch}
                    sortingAsc={this.props.sortingAsc}
                    sortingCriterion={this.props.sortingCriterion}
                    totalCount={this.props.totalCount}
                    modalProperties={modalProperties}
                />
            </div>
        );
    }
}
